export default "__VITE_ASSET__1de0fa39__"